module.exports = __webpack_public_path__ + "static/fonts/ibm-plex-mono-v12-latin-500italic.30a1577.ttf";